import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

import {BooleanValueCell} from './BooleanValueCell'

export const CementClassificationRow = ({material}: {material: Material}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.standard}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.type}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.const1}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.const2}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.strength1}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.strength2}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.sulphateResistance}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.sulphurLevel}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.heatOfHydration}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.lowAlkali}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.specialCharacteristics}</Typography>
    </TableCell>
    <BooleanValueCell value={material.classification?.intermediateMillProduct} />
    <TableCell>
      <Typography variant="caption">{material.classification?.categoryForAnnualReport}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">
        {material.classification?.referenceMeshSizeForResidue}
      </Typography>
    </TableCell>
  </>
)
